import {
  FETCH_GOVERNOR_DATA_PRODUCTS,
  APPEND_GOVERNOR_DATA_PRODUCTS,
  FETCH_GOVERNOR_DATA_PRODUCTS_REQUEST,
  APPEND_GOVERNOR_DATA_PRODUCTS_REQUEST,
  SET_GOVERNOR_DATA_PRODUCTS_LOADING,
  RESET_GOVERNOR_DATA,
} from '../../constants/reducerTypes';

const initialState = {
  dataProducts: {
    data: null,
    dploading: false,
    dperror: null,
    dpPageNumber: null,
    dpTotalPages: null,
    dpTotalItems: null,
  },
  dataProductRequests: {
    data: null,
    dprloading: false,
    dprerror: null,
    dprPageNumber: null,
    dprTotalPages: null,
    dprTotalItems: null,
  },
};

export default function governorDashboardReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_GOVERNOR_DATA_PRODUCTS:
      return {
        ...state,
        dataProducts: {
          data: action.payload.data,
          dploading: false,
          dperror: action.payload.error,
          dpPageNumber: action.payload.pageNumber,
          dpTotalPages: action.payload.totalPages,
          dpTotalItems: action.payload.totalItems,
        },
      };
    case SET_GOVERNOR_DATA_PRODUCTS_LOADING:
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          [action.payload.loader]: true,
        }
      };
    case APPEND_GOVERNOR_DATA_PRODUCTS:
      return {
        ...state,
        dataProducts: {
          ...state.dataProducts,
          data: [...(state.dataProducts?.data || []), ...(action.payload.data || [])],
          dploading: false,
          dperror: action.payload.error,
          dpPageNumber: action.payload.pageNumber,
          dpTotalPages: action.payload.totalPages,
          dpTotalItems: action.payload.totalItems,
        },
      };
    case FETCH_GOVERNOR_DATA_PRODUCTS_REQUEST:
      return {
        ...state,
        dataProductRequests: {
          data: action.payload.data,
          dprloading: false,
          dprerror: action.payload.error,
          dprPageNumber: action.payload.pageNumber,
          dprTotalPages: action.payload.totalPages,
          dprTotalItems: action.payload.totalItems,
        },
      };
    case APPEND_GOVERNOR_DATA_PRODUCTS_REQUEST:
      return {
        ...state,
        dataProductRequests: {
          ...state.dataProductRequests,
          data: [...(state.dataProductRequests?.data || []), ...(action.payload.data || [])],
          dprloading: false,
          dprerror: action.payload.error,
          dprPageNumber: action.payload.pageNumber,
          dprTotalPages: action.payload.totalPages,
          dprTotalItems: action.payload.totalItems,
        },
      };
    case RESET_GOVERNOR_DATA:
      return initialState;
    default:
      return state;
  }
}
